import api from './api'
import type { JobConnector, JobHandlers, JobResume } from './jobs'
import { notificationExcerpt } from './notificationText'

function eventLine(event: any): string {
  const kind = String(event?.kind || '')
  const text = String(event?.text || event?.output || '')
  if (kind === 'assistant_delta') return text
  if (kind === 'user_echo') return `\n\x1b[36mKullanıcı\x1b[0m  ${text}`
  if (kind === 'reasoning' || (kind === 'status' && event?.status === 'thinking')) return `\n\x1b[90mDüşünme: ${text}\x1b[0m`
  if (kind === 'tool_request') return `\n\x1b[33mAraç: ${event?.tool || 'işlem'}\x1b[0m`
  if (kind === 'tool_result') return text ? `\n${text}` : ''
  if (kind === 'permission_request') return `\n\x1b[33mİzin bekleniyor: ${event?.tool || 'araç'}\x1b[0m`
  if (kind === 'interaction_request') return `\n\x1b[35mAjan soru soruyor\x1b[0m`
  if (kind === 'error') return `\n\x1b[31m${text || 'Çalışma hatası'}\x1b[0m`
  if (kind === 'run_started') return '\n\x1b[32mAjan çalışmaya başladı\x1b[0m'
  if (kind === 'run_completed') return '\n\x1b[32mAjan çalışması tamamlandı\x1b[0m'
  return ''
}

export function createAiSessionJobConnector(sessionId: string, resume: JobResume): JobConnector {
  return (handlers: JobHandlers) => {
    let cursor = Number(resume.cursor || 0)
    let timer: number | null = null
    let stopped = false
    let polling = false
    let sawLive = false
    let quietPolls = 0
    let answerPreview = ''

    async function poll() {
      if (stopped || polling) return
      polling = true
      try {
        const response = await api.get(`/ai-cli/sessions/${sessionId}/history`, { params: { after_seq: cursor, limit: 1000 } })
        const events = Array.isArray(response.data?.events) ? response.data.events : []
        for (const event of events) {
          cursor = Math.max(cursor, Number(event?.seq || 0))
          if (String(event?.kind || '') === 'assistant_delta') {
            answerPreview = `${answerPreview}${String(event?.text || event?.output || '')}`.slice(-4000)
          }
          const line = eventLine(event)
          if (line) handlers.appendLine(line)
        }
        handlers.setResume({ ...resume, cursor })
        const live = response.data?.liveness?.run_active === true
        sawLive ||= live
        quietPolls = live ? 0 : quietPolls + 1
        if (sawLive && !live && quietPolls >= 2) {
          if (timer !== null) window.clearInterval(timer)
          handlers.appendLine('\n\x1b[90mCanlı çalışma sona erdi.\x1b[0m')
          // Yanıt Markdown olarak akar; kart ve sistem bildirimi düz metin
          // gösterdiği için başlık/madde yapısı korunarak sadeleştirilir.
          const excerpt = notificationExcerpt(answerPreview)
          handlers.finish(true, {
            category: 'ai', eventKey: 'ai.session_finished',
            body: excerpt || 'AI yanıtı hazır. Sohbeti açmak için dokunun.',
            url: `/ai-coding?session=${encodeURIComponent(sessionId)}`,
          })
        }
      } catch (error: any) {
        handlers.appendLine(`\n\x1b[31mCanlı konsol bağlantısı: ${error?.response?.data?.detail || error?.message || 'hata'}\x1b[0m`)
      } finally {
        polling = false
      }
    }
    void poll()
    timer = window.setInterval(poll, 1000)
    return { cleanup: () => { stopped = true; if (timer !== null) window.clearInterval(timer) } }
  }
}
